import { State } from 'app/redux';

export const getModuleNavigation = (state: State) => state.moduleNavigation;
